module.exports = __webpack_public_path__ + "img/icon-profit.3165e835.png";